import Reveal from "@/components/Reveal";
import { Phone } from "lucide-react";

const ZONES = [
  { num: "Z1", name: "CBD & Inner City", areas: "Sydney CBD, Surry Hills, Pyrmont, Glebe" },
  { num: "Z2", name: "Eastern Suburbs", areas: "Bondi, Randwick, Rosebery, Maroubra" },
  { num: "Z3", name: "North Shore & Beaches", areas: "Chatswood, Brookvale, Manly, Mona Vale" },
  { num: "Z4", name: "Inner West", areas: "Marrickville, Leichhardt, Strathfield, Five Dock" },
  { num: "Z5", name: "Western Sydney", areas: "Parramatta, Eastern Creek, Blacktown, Penrith" },
  { num: "Z6", name: "South & Sutherland", areas: "Alexandria, Mascot, Kogarah, Miranda" },
];

const Coverage = () => (
  <section id="coverage" data-testid="coverage-section" className="relative py-32 lg:py-40 bg-surface/30 border-y border-white/10 overflow-hidden">
    <div className="max-w-[1440px] mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-16 items-center">
      <div className="lg:col-span-6">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-frost font-bold mb-6 flex items-center gap-3">
            <span className="w-8 h-px bg-frost inline-block" />
            Coverage
          </p>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight uppercase font-medium">
            Every suburb,<br />same standard
          </h2>
          <p className="mt-8 max-w-lg text-mist font-light leading-relaxed">
            Six metro zones, one dispatch desk. Same-day service across Greater Sydney
            with scheduled runs to the Central Coast, Blue Mountains and Wollongong.
          </p>
        </Reveal>

        <div className="mt-12 border-t border-white/10">
          {ZONES.map((zone, i) => (
            <Reveal key={zone.num} delay={i * 0.06}>
              <div
                data-testid={`coverage-zone-${zone.num}`}
                className="group grid grid-cols-[64px_1fr] sm:grid-cols-[80px_200px_1fr] gap-4 items-baseline py-5 border-b border-white/10 hover:bg-white/[0.03] transition-colors duration-300 px-2"
              >
                <span className="font-mono text-xs text-frost font-bold">{zone.num}</span>
                <span className="font-display text-lg font-medium tracking-tight group-hover:text-ice transition-colors duration-300">
                  {zone.name}
                </span>
                <span className="hidden sm:block text-sm text-mist font-light">{zone.areas}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      <Reveal className="lg:col-span-6" delay={0.15}>
        <div className="relative">
          <div className="absolute -inset-6 border border-frost/20 pointer-events-none" aria-hidden="true" />
          <div className="relative overflow-hidden border border-white/10 [clip-path:polygon(0_0,100%_5%,100%_100%,0_95%)]">
            <img
              src="https://images.pexels.com/photos/57389/milsons-point-sydney-australia-sydney-opera-house-57389.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
              alt="Sydney harbour skyline illuminated at night"
              data-testid="coverage-image"
              loading="lazy"
              className="w-full h-[560px] object-cover"
            />
            <div className="absolute inset-0 bg-abyss/40" aria-hidden="true" />
            <div className="absolute bottom-8 left-8 right-8 bg-black/60 backdrop-blur-xl border border-white/10 p-6 flex items-center gap-4">
              <Phone className="w-5 h-5 text-frost shrink-0" strokeWidth={1.5} />
              <div>
                <p className="font-mono text-xs uppercase tracking-[0.2em] text-frost" data-testid="coverage-depot-label">
                  Dispatch desk
                </p>
                <p className="text-snow mt-1 font-light">24/7 — covering all of Greater Sydney</p>
              </div>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Coverage;
